export default "__VITE_ASSET__Cwx$nhXO__"